/**
 * Krok AI9 bod 1 — RANNÍ BRIEFING MAKLÉŘE jako POJMENOVANÉ SEKCE.
 *
 * Briefing sklada stejna data, ktera uz pocita Dnesek (`buildTodayEntries`,
 * `overdueTaskCount`/`splitTodayEntries`, `emailCardsOnYou`, `overdueInvoices`
 * v `index.ts`) — zadna druha implementace „co makler ma dnes dělat". Co je
 * NOVE oproti dlazdicim Dnesku: jedno pevne poradi „co hoří → koho zavolat →
 * prohlídky → úkoly" a pravidlo, ze PRAZDNA SEKCE SE VUBEC NEOBJEVI (zadani
 * AI9, test „briefing bez dat neukáže prázdné sekce") — Dnesek naproti tomu
 * dlazdici kresli vzdy, jen s „0" nebo vetou o klidu (`buildLede`).
 *
 * Volajici (web-admin) sestavi `BriefingInput` z primitiv, ktere uz ma
 * nactene na obrazovce Dnesek — tahle funkce uz jen rozhoduje o poradi a
 * skryvani prazdna, nic nenacita a nic neformatuje (zadne volani modelu,
 * cely vystup je D — deterministicky).
 */
const SECTION_ORDER = ['fires', 'to_call', 'viewings', 'tasks'];
/**
 * Sekce v pevnem poradi, PRAZDNE VYNECHANE. Briefing bez jedine veci k reseni
 * je prazdny seznam, ne ctyri prazdne karty — obrazovka tak nemusi filtrovat
 * podruhe.
 */
export function buildBrokerBriefing(input) {
    const byKey = {
        fires: input.fires,
        to_call: input.toCall,
        viewings: input.viewings,
        tasks: input.tasks,
    };
    return SECTION_ORDER.map((key) => ({ key, items: byKey[key] })).filter((section) => section.items.length > 0);
}
//# sourceMappingURL=broker-briefing.js.map